import React from 'react'
import { Seo } from '~/components/molecules/Seo'
import { Props, Screen } from '~/components/screens/funnels/custody/whitepaper'
import { site } from '~/config'
import { GetStaticProps } from 'next'
import { serialize } from 'next-mdx-remote/serialize'

const Page: React.FC<Props> = (props) => (
  <>
    <Seo
      title={`Custody Whitepaper | ${site.title}`}
      image={{
        url: `${site.host}/images/funnel/custody/ice-climber.webp`,
        height: 1121,
        width: 1695,
      }}
    />
    <Screen {...props} />
  </>
)

export default Page

export const getStaticProps: GetStaticProps<Props> = async () => {
  return {
    props: {
      trafficSource: 'twitter',
      hero: {
        blackText: true,
        heroImage: {
          mobile: {
            alt: 'ice climber',
            href: '/images/funnel/custody/ice-climber-mobile.webp',
          },
          desktop: {
            alt: 'ice climber',
            href: '/images/funnel/custody/ice-climber.webp',
          },
        },
      },
      heroContent: await serialize(heroMdx),
      bodyContent: await serialize(bodyMdx),
    },
  }
}

const heroMdx = `
# **Bitcoin custody, built for pioneers.**

We’re tired of seeing bad actors in this industry harm their customers, especially those building the products of tomorrow.

Custodia is built differently so that you can read headlines without worrying about your future. Learn more about our segregated custody model for digital assets and its unique, heightened protections.
`

const bodyMdx = `
### We serve U.S.-based business customers across all industries, including the pioneers who have adopted Bitcoin into their corporate treasury. We’re now accepting applications for Bitcoin custody and also other traditional financial products.\\*

You might have some questions, for example:

- Why is Custodia a bank?
- What is a segregated custody model and what advantages does it offer over an omnibus custody model? 
- How does Custodia maximize clarity of property rights for its customers?
- What is “bailment” and why does it matter?

Our whitepaper provides detailed answers to these questions and more. By completing this form, you are consenting to have Custodia contact you and tell you more about our services. Learn more about our [Privacy](/legal/privacy-notice) policy and [Terms of Service](/legal/terms-of-service).

## About Custodia

Custodia is a bank that operates under a special purpose depository institution legal and regulatory framework in the United States. This allows us to offer a full suite of financial services for both U.S. dollars\\* and digital assets that is tailored to business customers looking for enhanced regulatory clarity, defined property rights for assets, and minimized transactional risk.

Custodia services business customers such as:

- Digital asset businesses
- Fintechs  
- Banks
- Corporate treasurers
- Trusts
- Pension Funds
- Endowments
- Foundations
- Start-ups
- and many other types

Custodia looks forward to learning about your needs and helping you solve your business problems.

<sub>\\*Deposits at Custodia are not insured by the FDIC (Federal Deposit Insurance Corporation).</sub>
`
